import { HOST } from '../config';
import { apiGet } from '../api';

export const A = {
  REQUEST_GET_BILLING_DOCS: 'REQUEST_GET_BILLING_DOCS',
  RECEIVE_GET_BILLING_DOCS: 'RECEIVE_GET_BILLING_DOCS',
  ERROR_GET_BILLING_DOCS: 'ERROR_GET_BILLING_DOCS',
};

export const fetchBillingDocs = (data) => {
  const { id, size, page, date_from, date_to, filter_types } = data;

  let url = `${HOST}/api/lite/billing/documents?size=${size}&extended=true`;
  if (page) url += `&page=${page}`;
  if (id) url += `&id=${id}`;
  if (filter_types) url += `&filter_types=${filter_types}`;
  if (date_from) url += `&date_from=${date_from}`;
  if (date_to) url += `&date_to=${date_to}`;

  return (dispatch, getState) => {
    dispatch(requestGetBillingDocs());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetBillingDocs(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetBillingDocs(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetBillingDocs(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetBillingDocs = () => {
  return {
    type: A.REQUEST_GET_BILLING_DOCS,
  };
};

const receiveGetBillingDocs = (data) => {
  return {
    type: A.RECEIVE_GET_BILLING_DOCS,
    data,
  };
};

const errorGetBillingDocs = (err) => {
  return {
    type: A.ERROR_GET_BILLING_DOCS,
    err,
  };
};
